export default __webpack_public_path__ + "images/13_1_image.jpg";